import styled from "styled-components";
import { GridBase } from "../../../shared-styles";

const VerticalAlign = styled(GridBase)`
  display: grid;
  align-items: center;
`;

export { VerticalAlign };
